import { colors } from "@material-ui/core";

const white = "#FFFFFF";
const black = "#000000";

const ndPrimaryDark = "#314e80";
const ndPrimary = "#4770B7";
const ndPrimaryLight = "#6b8cc5";

const ndGreenDark = "#00927f";
const ndGreenPrimary = "#3EC3AE";
const ndGreenLight = "#78f6e0";

const Palette = {
  black,
  white,
  primary: {
    contrastText: white,
    dark: ndPrimaryDark,
    main: ndPrimary,
    light: ndPrimaryLight,
  },
  secondary: {
    contrastText: white,
    dark: ndGreenDark,
    main: ndGreenPrimary,
    light: ndGreenLight,
  },
  ndGreen: {
    contrastText: white,
    dark: ndGreenDark,
    main: ndGreenPrimary,
    light: ndGreenLight,
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  background: {
    default: "#F4F6F8",
    paper: white,
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200],
};

export default Palette;
